import { render, staticRenderFns } from "./DraggableWindow.vue?vue&type=template&id=5f512a59&scoped=true"
import script from "./DraggableWindow.vue?vue&type=script&lang=js"
export * from "./DraggableWindow.vue?vue&type=script&lang=js"
import style0 from "./DraggableWindow.vue?vue&type=style&index=0&id=5f512a59&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f512a59",
  null
  
)

export default component.exports